import React, { useEffect, useRef, useState } from 'react';

/**
 * Renders one deck slide as a real, self-contained 16:9 preview.
 *
 * The slides size their type and spacing in viewport units, so rendering them
 * inline at a scaled size collapses to an empty frame. Loading the deck itself
 * in an iframe at a fixed 1440×810 canvas gives each slide its own viewport,
 * then the whole frame is visually scaled to fit the thumbnail box.
 */
const BASE_WIDTH = 1440;
const BASE_HEIGHT = 810;
type SlidePreviewProps = {
  /** Screen id from canvas.manifest.js — seeds the slide via ?mp_screen=. */
  screenId: string;
  title: string;
  className?: string;
};
export function SlidePreview({
  screenId,
  title,
  className
}: SlidePreviewProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;
    const update = () => setWidth(element.getBoundingClientRect().width);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(element);
    window.addEventListener('resize', update);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', update);
    };
  }, []);
  const src = typeof window === 'undefined' ? '' : `${window.location.pathname}?mp_screen=${screenId}`;
  return <div ref={containerRef} className={`mp-thumb relative w-full overflow-hidden bg-[#0C0C0C] ${className ?? ''}`} style={{
    height: width ? width * 9 / 16 : undefined,
    aspectRatio: '16 / 9'
  }} data-id="element-288" data-mp="2pk7sz3nhxsfd">
      {width > 0 && src ? <iframe src={src} title={`${title} — slide preview`} tabIndex={-1} scrolling="no" className="mp-thumb-frame pointer-events-none absolute left-0 top-0 border-0" style={{
      width: BASE_WIDTH,
      height: BASE_HEIGHT,
      transform: `scale(${width / BASE_WIDTH})`,
      transformOrigin: 'top left'
    }} data-id="element-289" data-mp="3dfslgtbalcds" /> : null}
    </div>;
}